import { useLingui } from "@lingui/react/macro"
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  cn,
} from "@rarible_int/anaconda_ui_components"
import { ScannerIcon } from "../icons/scanner"

interface Props {
  url: string
  className?: string
}

export function ScannerLink({ url, className }: Props) {
  const { t } = useLingui()

  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <a
          target="_blank"
          rel="noreferrer"
          href={url}
          className={cn("flex h-5 items-center", className)}
        >
          <ScannerIcon />
        </a>
      </TooltipTrigger>
      <TooltipContent>{t`View on explorer`}</TooltipContent>
    </Tooltip>
  )
}
